import React, { useState, useContext } from "react";
import Button from "@material-ui/core/Button";
// golden ticket
import ticket_1 from '../icons/ticket_1.svg'
// silver ticket 
import ticket_2 from '../icons/ticket_2.svg'

import UserContext from "../Contexts/UserContext";
import Web3 from "web3";


export default function Userticket() {
  window.document.title = "Usertickets";
  var context = useContext(UserContext);
  let [isTicketBooked, setIsTicketBooked]=useState(context?.numOfTicketBookedByUser > 0)

  return (isTicketBooked ? <Booked/> : <NotBooked/>)
}
 
function Booked(){
  var context = useContext(UserContext);

  return(
    <section  
    style={{
      background:'#0005',
      width:'100%',
      height:'100vh',
      display:'flex',
      flexWrap:'wrap',
      justifyContent:'center',
      alignContent:'center'}}
    >
      <div style={{
        height:'400px',
        width:'800px',
        background:'url('+ticket_1+')',
        backgroundOrigin:'center',
        backgroundSize:'100% 100%',
        display:'flex',
        position:'relative',
        padding:'30px',
        paddingRight:'55px',
        justifyContent:'space-between'
        }}>
        <div style={{height:'100%',width:'25%',gridRow:'1',gridColumn:'1'}}>
        </div>
        <div style={{height:'100%',width:'75%',gridRow:'1',gridColumn:'2'}}>
          <h3 style={{textTransform:'uppercase',borderBottom:'2px dashed white',padding:'10px 0px'}}>Dappnovation Hackathon</h3>
          <kbd style={{padding:'10px',display:'block',marginTop:'5px',background:'#3d3dad'}}>EVENT DATE : 30/09/21</kbd><hr/>
          <kbd style={{float:'left',padding:'10px'}}>Amount Paid : {Web3.utils.fromWei(Web3.utils.toBN(context?.amountPaid), "ether")} ETH</kbd>
          <kbd style={{float:'right',padding:'10px'}}>Ticket Booked: {context?.numOfTicketBookedByUser}</kbd>
          <br style={{clear:'both'}}/> <hr/>
          <p>Dappnovation is a Dapp-Hackathon. It is an inter-college technical competiton. It is a platform where students from around the country can present their innovative ideas helpful in making the world a better place to live in. Dappnovation presents you all the opportunity to come together and work on your very own ideas and compete with other students.</p>
          <Button 
            variant="contained"
            color="secondary"
            style={{float:'right',fontSize:'1.2rem'}}
            onClick={()=>{context.cancelTicket()}}
            >
            CANCEL TICKET
          </Button>
        </div>
      </div>
    </section>
  )
}

function NotBooked(){
  var context = useContext(UserContext);

  return(
    <section  
    style={{
      background:'#0005',
      width:'100%',
      height:'100vh',
      display:'flex',
      flexWrap:'wrap',
      justifyContent:'space-around',
      alignContent:'space-around'
      }}
    >
      <div style={{
        height:'400px',
        width:'800px',
        background:'url('+ticket_2+')',
        backgroundOrigin:'center',
        backgroundSize:'100% 100%',
        display:'flex',
        position:'relative',
        padding:'30px',
        paddingRight:'55px',
        justifyContent:'space-between'
        }}>
        <div style={{height:'100%',width:'25%',gridRow:'1',gridColumn:'1'}}>
        </div>
        <div style={{
          height:'100%',
          width:'75%',
          gridRow:'1',
          gridColumn:'2',
         
          display:'flex',
          flexWrap:'wrap',
          justifyContent:'space-around',
          alignContent:'space-around',
          color:'black',
          fontSize:'2rem',
          textTransform:'uppercase',
          fontFamily:'monospace'
        }}>
        No Ticket Booked
        </div>
      </div>
    </section>
  )
}